import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AccountCreateModalUI from './AccountCreateModalUI'

class AccountCreateModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,

            // form events
            submitted: false,
            // form field
            panNumber: '',
            panNumberError: null,
        }
    }

    render() {
        return (
            <AccountCreateModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}
                // modes
                createAccountMode={this.props.createAccountMode}
                submitted={this.state.submitted}
                // event handlers
                onSubmit={this.onSubmit}
                onCancelClick={this.props.onCancelCreateAccount}
                // form fields
                panNumber={this.state.panNumber}
                onpanNumberChange={(event) => this.setState({ panNumber: event.target.value })}
                panNumberError={this.state.panNumberError}
                setpanNumberError={(error) => { this.setState({ panNumberError: error }) }}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
    }

    onSubmit = () => {
        let submitted = this.state.submitted
        if (submitted)
            return

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        RestApiUtils.post(this.props.context,
            `/api/su/accounts/pan`,
            this.onSubmitCallback, {
            panNumber: this.state.panNumber,
        }
        )
    }

    onSubmitCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({
                    successMsg: null
                })
                this.props.onCancelCreateAccount()
                this.props.onRefreshClick()
            }, 2000)
        }
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
    }
}

export default withRouter(AccountCreateModalSF)
